import { render } from "./SurveyList.vue?vue&type=template&id=2fab0e74"
import script from "./SurveyList.vue?vue&type=script&lang=js"
export * from "./SurveyList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__